import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
  
// jwt auth
const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const RegisterPage = Loadable(lazy(() => import('pages/auth/Register')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      children: [
        {
          index: true,
          element: <LoginPage />
        },
        {
          path: 'login',
          element: <LoginPage />
        },
        {
          path: 'add-subadmin',
          element: <RegisterPage />
        }
      ]
    }
  ]
};

export default LoginRoutes;
